import { OperationParameter, OperationURLParameter } from "@azure/core-client";
import {
  AddressSearchRequest as AddressSearchRequestMapper,
  SearchDrillDownRequest as SearchDrillDownRequestMapper,
  AddressRetrieveRequest as AddressRetrieveRequestMapper
} from "../models/mappers";

export const contentType: OperationParameter = {
  parameterPath: ["options", "contentType"],
  mapper: {
    defaultValue: "application/json",
    isConstant: true,
    serializedName: "Content-Type",
    type: {
      name: "String"
    }
  }
};

export const body: OperationParameter = {
  parameterPath: ["options", "body"],
  mapper: AddressSearchRequestMapper
};

export const accept: OperationParameter = {
  parameterPath: "accept",
  mapper: {
    defaultValue: "application/json",
    isConstant: true,
    serializedName: "Accept",
    type: {
      name: "String"
    }
  }
};

export const $host: OperationURLParameter = {
  parameterPath: "$host",
  mapper: {
    serializedName: "$host",
    required: true,
    type: {
      name: "String"
    }
  },
  skipEncoding: true
};

export const body1: OperationParameter = {
  parameterPath: ["options", "body"],
  mapper: SearchDrillDownRequestMapper
};

export const body2: OperationParameter = {
  parameterPath: ["options", "body"],
  mapper: AddressRetrieveRequestMapper
};
